<script setup>
import { getI18n } from '@/plugins/i18n'

defineProps({
  tile: { type: Object, required: true },
  mobile: { type: Boolean, default: false },
  editable: { type: Boolean, default: false },
  titleKey: { type: String, default: null },
  titleSuffix: { type: String, default: null },
  warehouseNames: { type: Array, default: () => [] },
  scrollable: { type: Boolean, default: false },
})
const emit = defineEmits(['delete', 'edit'])

const { t } = getI18n()
</script>

<template>
  <q-card class="dashboard-tile fit column no-wrap">
    <q-card-section class="tile-header q-pa-sm row items-start no-wrap">
      <q-icon
        name="mdi-view-dashboard-outline"
        size="xs"
        color="grey-5"
        class="q-mr-xs q-mt-xs"
      />
      <div class="col tile-title-row">
        <div class="text-subtitle2 ellipsis tile-title">
          {{ t(titleKey ?? tile.title) }}
        </div>
        <div v-if="titleSuffix || warehouseNames.length" class="warehouse-badges">
          <q-chip
            v-if="titleSuffix"
            size="sm"
            :label="titleSuffix"
            color="teal-6"
            text-color="white"
            class="q-ma-none"
          />
          <q-badge
            v-for="name in warehouseNames"
            :key="name"
            :label="name"
            color="blue-grey"
            text-color="white"
          />
        </div>
      </div>
      <div v-if="!mobile" class="tile-actions row no-wrap items-center">
        <q-btn
          v-if="editable"
          flat
          round
          size="xs"
          icon="mdi-cog-outline"
          color="grey-5"
          @mousedown.stop
          @click.stop="emit('edit')"
        />
        <q-btn
          flat
          round
          size="xs"
          icon="mdi-delete-outline"
          color="grey-5"
          @mousedown.stop
          @click.stop="emit('delete')"
        />
      </div>
    </q-card-section>
    <q-separator />
    <div class="col tile-body" :class="{ 'tile-body--scroll': scrollable }">
      <slot />
    </div>
  </q-card>
</template>

<style scoped>
.dashboard-tile {
  overflow: hidden;
  position: relative;
}
.tile-body {
  position: relative;
  overflow: hidden;
  min-height: 3.75rem;
  padding: 0.5rem;
  container-type: inline-size;
}
.tile-body--scroll {
  overflow-y: auto;
  overflow-x: hidden;
}
.tile-title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
}
.tile-title {
  flex: 1 1 auto;
  min-width: 40%;
}
.tile-actions {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  z-index: 2;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  opacity: 0;
  transition: opacity 0.2s;
}
.tile-header {
  cursor: move;
}
.tile-header:hover .tile-actions {
  opacity: 1;
}
.warehouse-badges {
  margin-left: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.2rem;
}
</style>
